import styled from 'styled-components';

export const ChartWrapperContainer = styled.div`
    position: relative;
`;
